<ion-app>
  <div class="aurora-bg" aria-hidden="true">
    <div class="aurora-estrellas"></div>
    <div class="aurora-cortina aurora-cortina--lejana"></div>
    <div class="aurora-cortina aurora-cortina--media"></div>
    <div class="aurora-cortina aurora-cortina--principal"></div>
  </div>
  <app-sidebar></app-sidebar>
  <!--
    Sin animación entre páginas: con el contenido transparente (para dejar ver
    la aurora) la página que entra no tapa a la que sale y se encimaban.
  -->
  <ion-router-outlet id="main-content" [animated]="false"></ion-router-outlet>

  <!--
    Avisos flotantes: viven fuera del router-outlet para verse en cualquier
    página. El aviso de versión nueva se pinta cuando hay una versión lista; el
    chip de vencimiento, cuando hay algo vencido o por vencer en menos de 3
    horas. Ninguno de esos dos se puede descartar sin atender lo que avisa. El
    de próxima reunión aparece 15 minutos antes y sí se puede ocultar.
  -->
  <div class="floating-notices-slot">
    <app-update-notice></app-update-notice>
    <app-upcoming-meeting-notice></app-upcoming-meeting-notice>
    <app-pending-task-due-soon-chip
      (chipClicked)="goToDueSoonPendingTasks()"
    ></app-pending-task-due-soon-chip>
  </div>
</ion-app>
